module.exports = __webpack_public_path__ + "public/img/ico-devicelist.30bc8ed7.svg";